import { classNames, splitFilenameAndExtension } from '../../utils';
import styles from './FormattedFileName.module.css';

interface FormattedFileNameProps {
    filename: string;
    inline?: boolean;
}

const FormattedFileName = ({
    filename,
    inline = false
}: FormattedFileNameProps) => {
    const slitFilename = splitFilenameAndExtension(filename);
    let name = slitFilename.name;
    let extension = slitFilename.extension;
    let lastFourCharacters = '';

    if (filename.length > 12) {
        lastFourCharacters = name.slice(-4);
        name = name.slice(0, -4);
        extension = lastFourCharacters + extension;
    }

    return (
        <div className={classNames(styles.filename, inline && styles.inlineFilename)}>
            <div className={styles.name}>{name}</div>
            <div>{extension}</div>
        </div>
    );
}

export default FormattedFileName;
